module.exports = __webpack_public_path__ + "img/exchange.87154083.svg";